import { translate, useLocale } from "../localization";
import React from "react";
import { Typography } from "@mui/material";
import { AppTextField } from "./ui";
import "./WorldUnitEditor.scss";

const unitOptions = () => [{
  value: 0,
  label: translate("fm")
}, {
  value: 1,
  label: translate("pm")
}, {
  value: 2,
  label: "A"
}, {
  value: 3,
  label: translate("nm")
}, {
  value: 4,
  label: translate("um")
}, {
  value: 5,
  label: translate("mm")
}, {
  value: 6,
  label: translate("cm")
}, {
  value: 7,
  label: "m"
}, {
  value: 8,
  label: translate("km")
}, {
  value: 9,
  label: translate("Mm")
}, {
  value: 10,
  label: translate("Gm")
}, {
  value: 11,
  label: translate("Tm")
}, {
  value: 12,
  label: translate("Pm")
}, {
  value: 13,
  label: translate("Em")
}, {
  value: 14,
  label: translate("parsec")
}, {
  value: 15,
  label: translate("megaParsec")
}, {
  value: 16,
  label: translate("lightYear")
}, {
  value: 17,
  label: translate("None")
}];

const WorldUnitEditor = ({
  worldUnit = {},
  onChange
}) => {
  useLocale();
  return <div className="world-unit-editor">
    <div className="world-unit-editor__panel">
      <div className="world-unit-editor__row">
        <Typography variant="subtitle1" className="world-unit-editor__title">{translate("World Unit:")}</Typography>
        <div className="world-unit-editor__fields">
          <div className="world-unit-editor__field">
            <AppTextField label={translate("Value")} value={worldUnit.value ?? ""} onChange={e => onChange("value", e.target.value)} size="small" fullWidth />
          </div>
          <div className="world-unit-editor__field">
            <AppTextField select label={translate("Unit")} value={worldUnit.units ?? 17} onChange={e => onChange("units", parseInt(e.target.value, 10))} size="small" SelectProps={{
              native: true
            }} fullWidth>
              {unitOptions().map(o => <option key={o.value} value={o.value}>
                  {o.label}
                </option>)}
            </AppTextField>
          </div>
        </div>
      </div>
    </div>
  </div>;
};

export default WorldUnitEditor;
